import { Dispatch, SetStateAction, useEffect, useState } from "react";
import { Toaster } from "react-hot-toast";
import { useHistory } from "react-router-dom";
import Button from "../../../../components/Button";
import IconButton from "../../../../components/IconButton";
import { InputMobile, LabelMobile, MergeLabelAndInputMobile } from "../../../../components/Input-Mobile/InputAndLabelMobile";
import { ModalPopUp } from "../../../../components/ModalPopUp";
import { toastError, toastSuccess } from "../../../../components/Toast";
import useAuthData from "../../../../hook/useAppData";
import { IconCheck, IconPencil, IconRightArrow } from "../../../../icons";
import { convertDate } from "../../../../libs/dateUtils";
import { Points, TimeSheetProps } from "../../model";
import { getPointsByDay, savePoints } from "../../service";
import { TitleMobile } from "../components/TitleMobile";
import { TypePoints } from "../form";
import "./index.scss";

export function HistoryEditMobile({
  setEditPage,
  dateRow,
  pointsEdit,
  setPointsEdit,
  listProject,
  info,
  setInfo,
  getAllPoints,
}: {
  setEditPage;
  dateRow;
  pointsEdit: Points;
  setPointsEdit: Dispatch<SetStateAction<Points>>;
  listProject: { id: number; name: string }[];
  info: { index: number; pointsOfDay: Points[] };
  setInfo: Dispatch<SetStateAction<{ index: number; pointsOfDay: Points[] }>>;
  getAllPoints: () => void;
}) {
  const { token, userId } = useAuthData();
  const [updatePoint, setUpdatePoint] = useState<Points>(pointsEdit);
  const [clickModal, setClickModal] = useState(false);

  const name = listProject?.find((project) => project?.id === updatePoint?.projectId)?.name;
  const nameWithLimitOfLength = name?.length > 17 ? name?.slice(0, 27) + "..." : name;

  function updateValue(target) {
    const { name, value } = target;
    setUpdatePoint({
      ...updatePoint,
      [`${name}`]: value,
    });
  }

  const convertHoursInNumber = (value) => {
    const hours = value?.split(":");
    const hoursNumber = hours?.[0] + hours?.[1];
    return +hoursNumber;
  };

  function DTOUpdatePoint(): TimeSheetProps {
    const points = info.pointsOfDay.map((point, index) => {
      if (index !== info.index) return point;
      return updatePoint;
    });
    return {
      points,
      date: dateRow,
      userId,
    };
  }

  function validPointUpdate() {
    if (convertHoursInNumber(updatePoint?.entrance) >= convertHoursInNumber(updatePoint?.exit)) {
      return { status: true, message: "Entrada menor/igual que Saída!" };
    }

    if (info.index + 1 <= info.pointsOfDay.length) {
      const nextPoint = info.pointsOfDay[info.index + 1];
      if (convertHoursInNumber(updatePoint?.exit) >= convertHoursInNumber(nextPoint?.entrance)) {
        return { status: true, message: "Saída maior/igual que Entrada do próximo ponto!" };
      }
    }

    if (info.index && convertHoursInNumber(info.pointsOfDay[info.index - 1].exit) > convertHoursInNumber(updatePoint?.entrance)) {
      return { status: true, message: "Ponto de Entrada menor que Saída anterior" };
    }
    return { status: false, message: "" };
  }

  async function saveUpdatePoint() {
    if (validPointUpdate().status) return toastError(validPointUpdate().message);
    const pointSaveUpdate = DTOUpdatePoint();
    const resSave = await savePoints(pointSaveUpdate, token);
    if (resSave.ok) {
      toastSuccess("Edição feita com Sucesso!");
      getAllPoints();
      setInfo(undefined);
      setPointsEdit(undefined);
      setTimeout(() => {
        setEditPage("details");
      }, 2000);
      return;
    }
    toastError("Não foi possível salvar a edição");
    return exitPopUp();
  }

  function exitPopUp() {
    return setClickModal(false);
  }

  return (
    <>
      <Toaster />
      <div className="h-full">
        <TitleMobile title={"Histórico de " + convertDate(dateRow)} onClick={() => setEditPage("details")} />
        <ModalPopUp status={clickModal} onClickCancel={exitPopUp} className="modal-save-edit-point">
          <div className="w-auto h-80 m-10 flex flex-col justify-between">
            <h2 className="flex justify-center text-6xl text-center">Deseja salvar a edição?</h2>
            <div className="flex justify-around items-end flex-row">
              <Button className="px-28 bg-secondary rounded-full shadow-2xl" onClick={() => exitPopUp()}>
                Cancelar
              </Button>
              <Button className="px-28 bg-primary rounded-full" onClick={saveUpdatePoint}>
                Salvar
              </Button>
            </div>
          </div>
        </ModalPopUp>
        <div className="flex flex-row items-center card-points h-4/5">
          <div className="flex h-full flex-col justify-center items-center bg-primary p-5 w-screen">
            <div className="card flex flex-col bg-white rounded-xl pt-10 h-4/5">
              <h2 className="text-white text-6xl bg-primary flex justify-center items-start rounded-2xl p-4 mx-20">Projeto</h2>
              <span className="text-center font-familyPoppins text-4xl text-textPrimary flex justify-center p-2 mt-5">{nameWithLimitOfLength}</span>
              <div className="flex flex-col justify-center mb-20 mt-36 mx-16 gap-2">
                <div className="flex flex-col">
                  <LabelMobile children="Entrada" />
                  <InputMobile name="entrance" className="w-full" type="time" value={updatePoint.entrance} onChange={(e) => updateValue(e.target)} />
                </div>
                <div className="flex flex-col">
                  <LabelMobile children="Saída" />
                  <InputMobile name="exit" className="w-full" type="time" value={updatePoint.exit} onChange={(e) => updateValue(e.target)} />
                </div>
              </div>
            </div>
            <span className="flex justify-center -mt-10 items-end content-end">
              <IconButton
                onClick={() => setClickModal(true)}
                icon={IconCheck}
                className="flex content-end justify-center rounded-full bg-white border border-gray-800 shadow-4xl w-20 h-20 text-black"
              />
            </span>
          </div>
        </div>
      </div>
    </>
  );
}
